// OrderListGrouped.js
import React, { useState, useEffect } from 'react';
import { Layout, Table, Typography, Spin, message, Divider } from 'antd';
import { fetchWithDeviceId } from './utils/deviceId';
import { render } from '@testing-library/react';
const { Content } = Layout;
const { Title } = Typography;

// 用户信息卡片组件，只展示头像、手机号、姓名、昵称
const UserInfoCard = ({ memberInfo, phone }) => (
  <div style={{ 
    width: '160px', 
    margin: '0 auto', 
    padding: '8px', 
    border: '1px solid #eee', 
    borderRadius: 4, 
    textAlign: 'center' 
  }}>
    {/* <img 
      src={memberInfo.head_img} 
      alt="头像" 
      style={{ width: 80, height: 80, borderRadius: '50%' }} 
    /> */}
    {!memberInfo.is_new && 
      <>
            <img src={memberInfo.head_img} alt="头像" style={{ width: 80, height: 80, borderRadius: '50%', marginTop: 8 }} />
            <div style={{ marginTop: 8, fontSize: '14px' }}>
              <div>
                <span style={{ fontWeight: 'bold' }}>手机号: </span>
                <span>{phone}</span>
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>姓名: </span>
                <span>{memberInfo.name}</span>
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>昵称: </span>
                <span>{memberInfo.nick_name}</span>
              </div>
            </div>
      </>
    }
    {
      memberInfo.is_new && 
      <>
          <div style={{ marginTop: 8, fontSize: '14px' }}>
            <div>
              <span style={{ fontWeight: 'bold' }}>新用户: </span>
              <span>{phone}</span>
            </div>
          </div>
      </>
    }
    
  </div>
);

// 默认会员信息（当后端数据未返回时使用占位）
const defaultMemberInfo = {

  head_img: 'https://via.placeholder.com/80',
  name: '新用户',
  nick_name: '新用户',
};

const orderColumns = [
  {
    title: '订单编号',
    dataIndex: 'id',
    key: 'id',
    width: 100,
  },
   {
    title: '用户姓名',
    dataIndex: 'owner_name',
    key: 'owner_name',
    width: 100,
  },
   {
    title: '经办人',
    dataIndex: 'agent_name',
    key: 'agent_name',
    width: 100,
  },
  {
    title: '容量',
    dataIndex: 'quantity',
    key: 'quantity',
    width: 100,
  },
  {
    title: '坛号',
    dataIndex: 'jar_name',
    key: 'jar_name',
    width: 150,
  },
  {
    title: '下单时间',
    dataIndex: 'create_time',
    key: 'create_time',
    render: (text) => formatDate(text),
    width: 180,
  },
  {
    title: '操作设备',
    dataIndex: 'device_nickname',
    key: 'device_nickname',
    width: 180,
  },
];
const formatDate = (isoDate) => {
    const d = new Date(isoDate);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    const hours = ('0' + d.getHours()).slice(-2);
    const minutes = ('0' + d.getMinutes()).slice(-2);
    const seconds = ('0' + d.getSeconds()).slice(-2);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
const OrderListGrouped = () => {
  const [groupedOrders, setGroupedOrders] = useState({});
  const [groupedOrdersKeys, setGroupedOrdersKeys] = useState(new Set());
  const [loading, setLoading] = useState(false);

  // 获取订单数据，并按手机号分组
  const fetchOrders = async () => {
    setLoading(true);
    try {

      const response = await fetchWithDeviceId(`${process.env.REACT_APP_API_BASE}/api/orderlist`);
      if (response.ok) {
        const data = await response.json();

        // 按手机号分组
        const groups = {};
        const keys = new Set();
        data.forEach(order => {
          let k = order.phone;
          if(!k){
            k = order.owner_name;
          }
          keys.add(k);
          if (!groups[k]) {
            groups[k] = [];
          }
          groups[k].push(order);
        });
        // 对每个组内的订单按下单时间排序（可根据需要调整）
        Object.keys(groups).forEach(phone => {
          groups[phone].sort((a, b) => new Date(a.create_time) - new Date(b.create_time));
        });

        setGroupedOrders(groups);
        setGroupedOrdersKeys(keys);
      } else {
        message.error('获取订单列表失败');
      }
    } catch (error) {
      console.info(error)
      message.error('获取订单列表出错');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ padding: '40px 80px' }}>
        <Title level={1}>订单列表</Title>
        <Spin spinning={loading}>
          {Array.from(groupedOrdersKeys).map(phone => {
            const orders = groupedOrders[phone];
            // 使用每组第一条订单中的会员信息，若缺失则使用默认占位信息
            const memberInfo = {
              is_new : orders[0].is_new || defaultMemberInfo.is_new,
              head_img: orders[0].head_img || defaultMemberInfo.head_img,
              name: orders[0].name || defaultMemberInfo.name,
              nick_name: orders[0].nick_name || defaultMemberInfo.nick_name,
            };
            return (
              <div key={phone} style={{ marginBottom: '40px' }}>
                {/* 显示用户信息卡片 */}
                <UserInfoCard memberInfo={memberInfo} phone={phone} />
                <Divider />
                {/* 展示该用户的所有订单 */}
                <Table 
                  dataSource={orders.map(order => ({ ...order, key: order.id }))}
                  columns={orderColumns}
                  pagination={false}  // 每组内暂不分页，可根据需要调整
                  bordered
                />
              </div>
            );
          })}
        </Spin>
      </Content>
    </Layout>
  );
};

export default OrderListGrouped;
